import { Routes } from '@angular/router';
import { NotFoundComponent } from './auth/components/not-found/not-found.component';

export const routes: Routes = 
[
    {
        path: '',
        loadChildren: () =>
          import('./auth/auth-routing.module').then((m) => m.AuthRoutingModule),
    },
    {
        path: "",
        loadChildren: () =>
          import("./dashboard/dashboard-routing.module").then((d) => d.DashboardRoutingModule),
        data: {
          language: "",
        },
      },
      {
        path: "",
        loadChildren: () =>
          import("./profile/profile-routing.module").then((p) => p.ProfileRoutingModule),
        data: {
          language: "",
        },
      },
      {
        path: "**",
        component: NotFoundComponent,
      },
      {
        path: "not-found",
        component: NotFoundComponent,
      },
];
